<template>
    <div style="display: contents">
        <app-button type="primary" @click="calculateMigrationProgress">
            Calculate Progress
        </app-button>

        <app-button type="light" @click="resetMigration">
            Reset Migration
        </app-button>

        <loading-overlay :loading="loading"></loading-overlay>
    </div>
</template>

<script>
import axios from "axios";
import route from "ziggy-js";

export default {
    props: {
        connectionId: {
            type: String
        }
    },

    data() {
        return {
            loading: false
        }
    },

    methods: {
        resetMigration() {
            if (!confirm('Are you sure want to reset migration in LMS?')) {
                return;
            }

            this.loading = true;
            return axios.post(this.route('moodle.reset-migration', {connection: this.connectionId}))
                .then(response => {
                    if (response.status) {
                        this.$notifications.success('Migration reseted.');
                    } else {
                        this.$notifications.error('Migration not reseted.');
                    }
                    this.loading = false;
                })
        },
        calculateMigrationProgress() {
            if (!confirm('Are you sure want to calculate the progress?')) {
                return;
            }

            this.loading = true;
            return axios.post(this.route('moodle.calculate-migration-progress', {connection: this.connectionId}))
                .then(response => {
                    if (response.data.status == 'success') {
                        this.$notifications.success(response.data.message);
                    } else {
                        this.$notifications.error('Error with migration progress calculation:' + response.data.message);
                    }
                    this.loading = false;
                })
        }
    }
}
</script>
